module.exports = __webpack_public_path__ + "media/images/shield_color-e3f972f7.png";